exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cards-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.load-more-button {\n  color: #9b9b9b;\n  border: solid #4ec8ed 1.75px; }\n\n.load-more-button:hover {\n  color: white;\n  background-color: #06a6d3;\n  border-color: #06a6d3; }\n", ""]);

// exports
